import { render, staticRenderFns } from "./PopupNotificationComponent.vue?vue&type=template&id=e7d170cc&scoped=true&"
import script from "./PopupNotificationComponent.vue?vue&type=script&lang=js&"
export * from "./PopupNotificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./PopupNotificationComponent.vue?vue&type=style&index=0&id=e7d170cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d170cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardSubtitle,VCardTitle})
